import React from 'react';
import { useFiscalYear } from '../contexts/FiscalYearContext';

/**
 * Global Fiscal Year selector — sits in the top header.
 *
 * - Renders nothing while loading or if the list is empty.
 * - The selection is persisted in localStorage by FiscalYearContext.
 * - The selected FY's date range is read by reports / dashboard widgets via
 *   `useFiscalYear().getDateRange()`.
 */
const FiscalYearSelector = ({ variant = 'mobile' }) => {
  const { fiscalYears, selectedFyId, setSelectedFyId, currentFyId, loading } = useFiscalYear();

  if (loading || !fiscalYears || fiscalYears.length === 0) return null;
  // Both desktop & mobile instances mount simultaneously (Tailwind hides one
  // via responsive utilities). Use a variant-specific id to avoid duplicate
  // HTML ids in the DOM.
  const id = `global-fy-select-${variant}`;

  return (
    <div className="hidden sm:flex items-center gap-1" data-testid="fy-selector-wrapper">
      <label
        className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wide"
        htmlFor={id}
      >
        FY
      </label>
      <select
        id={id}
        value={selectedFyId || ''}
        onChange={(e) => setSelectedFyId(e.target.value)}
        className="text-xs sm:text-sm font-semibold border border-gray-300 rounded px-2 py-1 bg-white hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer max-w-[140px]"
        data-testid="global-fy-select"
      >
        {fiscalYears.map((fy) => (
          <option key={fy.id} value={fy.id}>
            {fy.name}{fy.id === currentFyId ? ' • current' : ''}{fy.status === 'closed' ? ' • closed' : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FiscalYearSelector;
